import React from 'react';
import { Hero } from './components/Hero';
import { ProfessionalAudience } from './components/ProfessionalAudience';
import { StatsBar } from './components/StatsBar';
import { TestimonialStrip } from './components/TestimonialStrip';
import { Problems } from './components/Problems';
import { Modules } from './components/Modules';
import { ModuleIncludes } from './components/ModuleIncludes';
import { Comparison } from './components/Comparison';
import { Bonuses } from './components/Bonuses';
import { PricingPack } from './components/PricingPack';
import { Guarantee } from './components/Guarantee';
import { Reviews } from './components/Reviews';
import { CostOfNotBuying } from './components/CostOfNotBuying';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <main className="w-full overflow-x-hidden bg-mist font-sans text-navy antialiased" data-id="element-0" data-mp="23vciyq2516ak">
      <Hero data-id="element-1" data-mp="23ti8y6semyl9" />
      <ProfessionalAudience data-id="element-2" data-mp="3ijxo6nd1puib" />
      <StatsBar data-id="element-3" data-mp="3ikqz80j1f669" />
      <TestimonialStrip data-id="element-4" data-mp="3ij668fcdfvai" />
      <Problems data-id="element-5" data-mp="3ihv2gfixenje" />
      <Modules data-id="element-6" data-mp="3mlj9mx3nbh44" />
      <ModuleIncludes data-id="element-7" data-mp="3mlatmwc87vop" />
      <Comparison data-id="element-8" data-mp="3mkhn9wh6j873" />
      <Bonuses data-id="element-9" data-mp="3mjzu58ptda3e" />
      <PricingPack data-id="element-10" data-mp="3mjga9mglsbmq" />
      <Guarantee data-id="element-11" data-mp="3rc9dg5wfbbwp" />
      <Reviews data-id="element-12" data-mp="3rbrbcsn2y3gv" />
      <CostOfNotBuying data-id="element-13" data-mp="3rdaq2et386gj" />
      <FAQ data-id="element-14" data-mp="3rcsuzli5vya7" />
      <FinalCTA data-id="element-15" data-mp="3recedkz46pg7" />
      <Footer data-id="element-16" data-mp="5yjetptzbev" />
    </main>;
}